'use client'
import type { GetPartnerSettings200ResponseDataInner } from '@/services/Api/generated'
import { createContext, ReactNode, useContext, useMemo } from 'react'

export type PartnerSettings = GetPartnerSettings200ResponseDataInner[]

const PartnerSettingsContext = createContext<PartnerSettings | undefined>(
  undefined
)

interface PartnerSettingsProviderProps {
  children: ReactNode
  // Настройки партнёра, полученные на сервере (getPartnerSettings)
  settings: PartnerSettings
}

export const PartnerSettingsProvider = ({
  children,
  settings,
}: PartnerSettingsProviderProps) => {
  return (
    <PartnerSettingsContext.Provider value={settings}>
      {children}
    </PartnerSettingsContext.Provider>
  )
}

export const usePartnerSettings = (): PartnerSettings => {
  const context = useContext(PartnerSettingsContext)

  if (context === undefined) {
    throw new Error(
      'usePartnerSettings must be used within PartnerSettingsProvider'
    )
  }

  return context
}

// Значение конкретной настройки по группе и ключу.
// Отсутствующая или пустая строка — undefined.
export const usePartnerSetting = (
  group: string,
  key: string
): string | undefined => {
  const settings = usePartnerSettings()

  return useMemo(() => {
    const value = settings.find(
      (item) => item.group === group && item.key === key
    )?.value

    if (value == null) {
      return undefined
    }

    const trimmed = value.trim()

    return trimmed === '' ? undefined : trimmed
  }, [settings, group, key])
}
